import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconAccordion.module.css';

const IconAccordion = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 12L10 6L4 12"
        stroke="#7D5559"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconAccordion.defaultProps = {
  className: null,
  rootClassName: null,
};

IconAccordion.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconAccordion;
